<div class="modal-header mainColor">
    <h6 class="modal-title text-center" *ngIf="from=='lider'">{{"action_plan.members.modal_leader"  | translate}}</h6>
    <h6 class="modal-title text-center" *ngIf="from=='guest'">{{"action_plan.members.modal_guest"  | translate}}</h6>
    <button type="button" class="close dangerButton" aria-label="Close" style="opacity: 1;" (click)="btnDismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <ng-container *ngIf="!loading;else spinner">
        <div class="row mt-3">
            <div class="col-10 m-auto">
                <div class="row mb-1">
                    <div class="col-12 d-flex justify-content-between">
                        <div class=" text-left" style="width: 200px;margin-left: 2px;">
                            <h6 style="color:#126db3">{{"action_plan.members.username"  | translate}}</h6>
                        </div>
                        <div class=" text-left" style="width: 211px;">
                            <h6 style="color:#126db3">{{"action_plan.members.user"  | translate}}</h6>
                        </div>
                    </div>

                </div>
                <div class="row">
                    <div class="col-12 form-grey px-1 py-1"
                        style="min-height: 150px;max-height: 200px;overflow-y: auto;overflow-x: hidden;">
                        <ng-container *ngFor="let user of users">
                            <div class="col-12 d-flex justify-content-between">
                                <div class=" text-left" style="width: 200px;">
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" class="custom-control-input"
                                            (change)="checkUser($event,user,'user')" [(ngModel)]="user.checked">
                                        <label class="custom-control-label" for="customCheck1">
                                            {{user.name}}</label>
                                    </div>
                                </div>
                                <div class="text-left" style="width: 200px;">{{user.username}}</div>
                            </div>

                        </ng-container>
                    </div>

                </div>
            </div>
        </div>
        <!-- <div class="row mt-4 pt-2">
            <div class="col-10 m-auto">
                <div class="row mb-1">
                    <div class="col-12 d-flex justify-content-between">
                        <div class=" text-left" style="width: 200px;margin-left: 2px;">
                            <h6 style="color:#126db3">{{"action_plan.members.group_name"  | translate}}</h6>
                        </div>

                    </div>

                </div>
                <div class="row">
                    <div class="col-12 form-grey px-1 py-1"
                        style="min-height: 150px;max-height: 200px;overflow-y: auto;overflow-x: hidden;">
                        <ng-container *ngFor="let grupo of grupos">
                            <div class="col-12 d-flex justify-content-between">
                                <div class=" text-left" style="width: 200px;">
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" class="custom-control-input"
                                            (change)="checkUser($event,grupo,'group')">
                                        <label class="custom-control-label" for="customCheck1">
                                            {{grupo.nombre}}</label>
                                    </div>
                                </div>
                            </div>

                        </ng-container>
                    </div>

                </div>
            </div>
        </div> -->
    </ng-container>
    <ng-template #spinner>
        <div class="col-12 d-flex justify-content-center align-items-center">
            <img src="./assets/img/Simbolodeespera1.gif" alt="" style="width: 150px;">
        </div>

    </ng-template>

</div>
<div class="modal-footer">
    <button type="button" ngbAutofocus class="btn dangerButton"
        (click)="btnDismiss()">{{"globals.buttons.cancelar"  | translate}}</button>
    <button type="button" ngbAutofocus class="btn acceptButton"
        (click)="btnClose()">{{"globals.buttons.accept"  | translate}}</button>
</div>